import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const RESEND_EMAIL = gql`
  mutation ResendActivationEmail($email: String!) {
    user {
      resendActivationEmail(email: $email)
    }
  }
`;

const resendEmailRequest = ({ email, onError, onSuccessResult }) => (
  <Mutation mutation={RESEND_EMAIL}>
    {(resendActivationEmail, { loading, error, data }) => {
      const variables = {
        email,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult();
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={resendActivationEmail}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

resendEmailRequest.propTypes = {
  email: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
};

export default resendEmailRequest;
